module.exports = __webpack_public_path__ + "img/banner2_4.3d9d05bb.png";